import { Component, Inject, ChangeDetectorRef, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Http } from '@angular/http';
import { MemberService } from './../services/Member.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Directive, HostBinding, Input} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { parse } from 'querystring';




import * as $ from 'jquery'
import 'datatables.net';
import 'datatables.net-bs4';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/dataTables.buttons.js';
import 'datatables.net-buttons/js/buttons.print.js';

@Directive({
  selector: '[sanitizeHtml]'
})
export class SanitizeHtmlDirective {
 
  @Input() sanitizeHtml: string;
 
  constructor(private sanitizer: DomSanitizer) {
  }
 
  @HostBinding('innerHtml')
  get innerHtml(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.sanitizeHtml);
  }
 
}


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  RegRequest: FormGroup;
  TotalUser: any;
  TotalActive     :any;
  TotalBlock      :any;
  TodayJoin       :any;
  LeftTotalUser   :any;
  RightTotalUser  :any;
  LeftActiveUser  :any;
  RightActiveUser :any;
  LeftDirectUser  :any;
  RightDirectUser: any;
  TotalIncome: any;
  ROIIncome: any;
  ROIIncomeMonthly: any;
  DirectIncome: any;
  PerforamnceIncome: any;
  Wallet: any;
  RepurchaseWallet: any;
  PerformanceWallet: any;
  GOIWallet: any;
  UserCode: any;
  ProfilePath: string = "UserPhoto/0.jpg";
  errorMessage: any;
  Message: string = '';

  MessageType: string = 'warning';

  ngOnInit() {
    this.MessageType = 'warning';
    this.Message = "Please Wait Loading ...!";
    this.MsgHide();
  }

   

  News = [];
  NotificationMessage = [];

         
 // ProfilePath: string = 'assets/UserPhoto/0.jpg';
  MemberCode: string = '';
  MemberName: string = '';
  Package: string = '';
  Contact: string = '';
  DOJ: string = '';
  DOA: string = '';
  Status: string = '';
  SponsorCode: string = '';
  SponsorName: string = '';
  DaysLeft: string = '';
  

  UserId: number = 0;
  UserType: string = '';

  Pagename: string = 'Home';
  dataTable: any;

  constructor(http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private _fb: FormBuilder,
    private _memberService: MemberService,
    private _avRoute: ActivatedRoute,
    private _router: Router,
    private cd: ChangeDetectorRef,
    private chRef: ChangeDetectorRef) {

    this.RegRequest = this._fb.group({
      PaymodeId: [''],
      BankName: [''],
      AccountName: [''],
      AccountNo: [''],
      IfscCode: [''],
      GooglePay: [''],
      PhonePay: [''],
      Paytm: [''],
      PackageName: [''],
      RegistrationFee: [''],
      PackageId: [''],
      Photo: [''],
    })

    this._memberService.GetSession().subscribe((data) => {

      

      this.UserCode = data[0].UserCode;
      this._memberService.FillHomeData(data[0].UserId, data[0].UserType).subscribe((data) => {
        console.log(data);
        //this.TotalUser = data[0].TotalUser;
        //this.TotalActive = data[0].TotalActive;
        //this.TotalBlock = data[0].TotalBlock;
        //this.TodayJoin = data[0].TodayJoin;
        //this.LeftTotalUser = data[0].LeftTotalUser;
        //this.RightTotalUser = data[0].RightTotalUser;
        //this.LeftActiveUser = data[0].LeftActiveUser;
        //this.RightActiveUser = data[0].RightActiveUser;
        //this.LeftDirectUser = data[0].LeftDirectUser;
        //this.RightDirectUser = data[0].RightDirectUser;
        this.ROIIncome = data[0].ROIIncome;
        //this.ROIIncomeMonthly = data[0].ROIIncomeMonthly;
        this.DirectIncome = data[0].DirectIncome;
        //this.PerforamnceIncome = data[0].PerforamnceIncome;
        //this.Wallet = data[0].Wallet;
        //this.RepurchaseWallet = data[0].RepurchaseWallet;
        //this.PerformanceWallet = data[0].PerformanceWallet;
        //this.GOIWallet = data[0].GOIWallet;
        this.TotalIncome = data[0].TotalIncome;
       this.RegRequest.controls['AccountName'].setValue(data[0].AccountName);
        this.RegRequest.controls['AccountNo'].setValue(data[0].AccountNo);
        this.RegRequest.controls['IfscCode'].setValue(data[0].IfscCode);
       this.RegRequest.controls['BankName'].setValue(data[0].BankName);
          this.RegRequest.controls['GooglePay'].setValue(data[0].GooglePay);
        this.RegRequest.controls['PhonePay'].setValue(data[0].PhonePay);
        this.RegRequest.controls['Paytm'].setValue(data[0].Paytm);


       

        

      }, error => console.error(error));

      this.UserType = data[0].UserType;

      this._memberService.GetNotification(data[0].UserId, data[0].UserType).subscribe((data) => {

        console.log(data);
        this.NotificationMessage = data;

      });

      this._memberService.GetUserDetail(data[0].UserId)
        .subscribe((data) => {
          // this.MemberProfileform.controls['UserId'].setValue(data[0].UserId);
          if (this.UserType == 'Admin') {
            this.MemberCode = 'Admin';
            this.MemberName = 'Admin';
            this.ProfilePath = "UserPhoto/" + data[0].UserId + ".jpg";
            this.Package = data[0].PackageName;
            this.Contact = data[0].ContactNo;
            this.DOJ = data[0].DOJ;
            this.DOA = data[0].DOA;
            this.Status = data[0].Status;
            this.DaysLeft = data[0].DaysLeft;
            this.SponsorCode = data[0].SponorCode_d;
            this.SponsorName = data[0].SponsorName_d;
            this.RegRequest.controls['PackageName'].setValue(data[0].PackageName);
            this.RegRequest.controls['PackageId'].setValue(data[0].PackageId);
            this.RegRequest.controls['RegistrationFee'].setValue(data[0].RegistrationFee);

    


            if (data[0].Status == "Active") {
              $('.showthispanel').hide();
            }
            else { $('.showthispanel').hide(); }

          }
          else {
            this.MemberCode = data[0].UserCode;
            this.MemberName = data[0].UserName_d;
            this.ProfilePath = "UserPhoto/" + data[0].UserId + ".jpg";
            this.Package = data[0].PackageName;
            this.Contact = data[0].ContactNo;
            this.DOJ = data[0].DOJ;
            this.DOA = data[0].DOA;
            this.Status = data[0].Status;
            this.DaysLeft = data[0].DaysLeft;
            this.SponsorCode = data[0].SponorCode_d;
            this.SponsorName = data[0].SponsorName_d;
            this.RegRequest.controls['PackageName'].setValue(data[0].PackageName);
            this.RegRequest.controls['PackageId'].setValue(data[0].PackageId);
            this.RegRequest.controls['RegistrationFee'].setValue(data[0].RegistrationFee);


            if (data[0].Status == "Active") {
              $('.showthispanel').hide();
            }
            else { $('.showthispanel').hide(); }

          }

         
        });


     


    });




    this._memberService.GetNews().subscribe((data) => {


      this.News = data;

    });

   





  }

  GetPaymodeValue(PaymodeId: string)
  {
    //this.Message = PaymodeId;
    //this.MessageType = 'Success';
    //$("#message").show();
   this.RegRequest.controls['PaymodeId'].setValue(PaymodeId);
  }

  public UpdateRegistrationSlip(RegistrationSlipId: string) {
   // $("#message").show();
    this._memberService.UpdateRegistrationSlip(this.RegRequest.value, RegistrationSlipId)
      .subscribe((data) => {
        //console.log(data);
        //this.Message = data[0].Message;
        //if (data[0].MessageType == 1) {
        //  //this.FillForm(0);
        //  this.MessageType = 'success';
        //}
        //else {
        //  this.MessageType = 'warning';
        //}


      }, error => this.errorMessage = error);

  }

  onFileChange(event) {
    var pic;
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.RegRequest.patchValue({
          Photo: reader.result
        });
        pic = reader.result
        this.chRef.markForCheck();

        //$(document).ready(function () {
        //  $('#Profilepic').attr('src', pic);
        //});

      };

      $(document).ready(function () {
        $(".message").show();
      });

    }
  }


  save() {
    //var PackageName = this.RegRequest.controls['PackageName'].value;
    //var PaymodeId = this.RegRequest.controls['PaymodeId'].value;
    //var PackageId = this.RegRequest.controls['PackageId'].value;
    //if (PaymodeId != '') {
    //  this._memberService.GetSession().subscribe((data) => {
    //    this._memberService.SaveMemberRequest(
    //      data[0].UserId,
    //      data[0].UserType,
    //      PackageId,
    //      '0',
    //      PaymodeId
    //    )
    //      .subscribe((data) => {
    //        console.log(data);
    //        this.Message = data[0].Message;
    //        if (data[0].MessageType == 1) {
    //          this.UpdateRegistrationSlip(data[0].RequestId);
    //          this.MessageType = 'success';
    //        }
    //        else {
    //          this.MessageType = 'warning';
    //        }
    //      }, error => this.errorMessage = error);
    //  });
    //}
    //else {
    //  this.MessageType = 'warning';
    //  this.Message = ' Please Select Payment Mode...!';
    //}

    //$(document).ready(function () {
    //  $("#message").show();
    //});
  }

  public MsgHide() {
    $(document).ready(function () {
      $("#message").hide();
    });
  }

  get PaymodeId() { return this.RegRequest.get('PaymodeId'); }
  get BankName() { return this.RegRequest.get('BankName'); }
  get AccountNo() { return this.RegRequest.get('AccountNo'); }
  get IfscCode() { return this.RegRequest.get('IfscCode'); }
  get GooglePay() { return this.RegRequest.get('GooglePay'); }
  get PhonePay() { return this.RegRequest.get('PhonePay'); }
  get Paytm() { return this.RegRequest.get('Paytm'); }
  get AccountName() { return this.RegRequest.get('AccountName'); }
  get PackageName() { return this.RegRequest.get('PackageName'); }
  get RegistrationFee() { return this.RegRequest.get('RegistrationFee'); }
  get PackageId() { return this.RegRequest.get('PackageId'); }



 // get packagename2() { return this.RegRequest.get('packagename2'); }


}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts